module.exports = __webpack_public_path__ + "img/grail.da805eb1.png";